function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n        .prefix__st0{fill:#0f82b7}\n    ");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M272 160c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h32zm-24-32h16v16h-16v-16z",
  className: "prefix__st0"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 192,
  cy: 328,
  r: 8,
  className: "prefix__st0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M175 295c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0c3.2-3 8.2-3 11.3 0 3.1 3.1 8.2 3.1 11.3 0 3.1-3.1 3.1-8.2 0-11.3-9.4-9-24.4-9-33.9 0zM242.9 261.1c1.5 1.5 3.5 2.3 5.7 2.3 4.4 0 8-3.6 8-8 0-2.1-.8-4.2-2.3-5.7-34.4-34.3-90.1-34.3-124.4 0-3.1 3.2-3 8.2.2 11.3 3.1 3 8 3 11.1 0 28-28 73.6-28 101.7.1z",
  className: "prefix__st0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M152.4 272.4c-3.2 3.1-3.3 8.1-.2 11.3 3.1 3.2 8.1 3.3 11.3.2l.2-.2c15.6-15.6 40.9-15.6 56.6 0 1.5 1.5 3.5 2.3 5.7 2.3 4.4 0 8-3.6 8-8 0-2.1-.8-4.2-2.3-5.7-22-21.8-57.4-21.8-79.3.1zM304 400c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm0 32c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z",
  className: "prefix__st0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M424 456.2V432c-.1-18.1-12.3-33.9-29.8-38.5 8.8-8.9 13.8-20.9 13.8-33.5v-48c0-22.1-17.9-40-40-40h-48c-4.4 0-8 3.6-8 8v72h-45.1c33.7-34.8 38.6-88.1 12.4-128.4-15.2-24-34.3-34.6-47.3-39.6-43.8-18.4-96.1-4.8-124.9 35.6-33.3 46.8-22.4 111.7 24.3 145.1 27 19.2 61.6 24.5 93 14-.3 1.8-.5 3.5-.5 5.3v80c0 5.6 1.6 11.2 4.4 16H208v-24c0-4.4-3.6-8-8-8h-8v-32c0-4.4-3.6-8-8-8s-8 3.6-8 8v32h-48v-32c0-4.4-3.6-8-8-8s-8 3.6-8 8v32h-8c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h328c4.4 0 8-3.6 8-8 0-12.5-6-24.3-16-31.8zM192 480h-80v-16h80v16zm216-48v16.8c-2.6-.5-5.3-.8-8-.8h-16v-40c13.3 0 24 10.7 24 24zm-80-144h40c13.3 0 24 10.7 24 24h-64v-24zm-208.1 43c-28.1-39.7-18.8-94.7 20.9-122.8 28.4-20.1 65.8-21.5 95.4-4.2.5.3 1.1.6 1.6 1 .6.3 1.1.7 1.7 1 .2.1.4.3.6.4.9.6 1.8 1.2 2.7 1.9.2.2.5.3.7.5 6.5 4.7 13.4 10.9 19.6 19.6.1.2.2.4.3.5 0 .1.1.1.1.2 28.1 39.7 18.8 94.7-20.9 122.8C203 380.1 148 370.7 119.9 331zM368 480H256c-8.8 0-16-7.2-16-16v-80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96zm-16-128h-24v-24h64v32c0 7.9-3 15.5-8.3 21.4-1.3-16.6-15.1-29.3-31.7-29.4zm32 128v-16h16c10.2 0 19.2 6.4 22.6 16H384z",
  className: "prefix__st0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M495.7 149.9c-.6-2.1-2-3.9-3.9-4.9l-232-128c-2.4-1.3-5.3-1.3-7.7 0l-232 128c-3.9 2.1-5.3 7-3.1 10.9 0 .1.1.2.1.3l24 40c2.2 3.7 7.1 5 10.9 2.8l4-2.3v289.2c0 5.6 3.6 10.2 8 10.2s8-4.6 8-10.2V312.2 187.4L256 81.2l93 53.6.1.1.8.5 29.5 17 60.6 35V448c0 4.4 3.6 8 8 8s8-3.6 8-8V196.6l4 2.3c3.8 2.2 8.6.9 10.9-2.8l24-40c1.1-1.8 1.4-4.1.8-6.2zm-34.5 31.2l-75.6-43.6-27.7-16L260 65.1c-2.5-1.4-5.5-1.4-8 0l-201.2 116L35.1 155 256 33.1 476.9 155l-15.7 26.1z",
  className: "prefix__st0"
});

var SvgInternet = function SvgInternet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Layer_1",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInternet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/internet.b1f8863e.svg";
export { ForwardRef as ReactComponent };